module.exports = {
      id: "app-store-usage",
      viewBox: "0 0 144 48",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#app-store",
      toString: function () {
        return this.url;
      }
    }